import React, { useEffect } from 'react';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import CustomButton from 'components/CustomInput/Button';
import CustomTable from 'components/CustomTable';
// import PopupInput from 'components/Application/TeamMemberForm/PopupInput';
import useSitePIDelegateData from 'hooks/tableData/useSitePIDelegateData';
import MemberDialog from './MemberDialog';
import useDialog from 'components/ConfirmDialog/useDialog';
import { EMAIL_EXIST_EMAIL } from 'utility/frontendMessage';
import { compareEmail, initializeTableData } from 'utility/general';

const SiteDelegationTable = ({
    applicationDetail,
    siteInfoId,
    disableOnPermission = false,
    isAmendmentCreate = false,
    isAmendmentEdit = false,
    isHighlight = () => {},
}) => {
    const {
        openPopup,
        setOpenPopup,
        columns,
        rows,
        selectedRow,
        handleEditClick,
        handleEditAfterCreation,
        handleCreateAfterCreation,
        handleDeleteAfterCreation,
        triggerFormCreate,
        isEdit,
        setRows,
    } = useSitePIDelegateData({ formId: applicationDetail?.applicationForm?.id, siteInfoId });

    const showDialog = useDialog();

    const isAmendment = isAmendmentCreate || isAmendmentEdit;

    // initialize the site-info postData if edit data exist
    useEffect(() => {
        const newData = initializeTableData({
            tableKey: 'piDelegation',
            currentTableData: rows,
            siteInfoId,
        });

        setRows(newData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: 20,
                    paddingBottom: 10,
                    alignItems: 'center',
                }}
            >
                <TextSubHeader>
                    <span style={{ background: isHighlight(['piDelegation'], true) ? 'yellow' : 'initial' }}>
                        Site Principal Investigator’s Delegation
                    </span>
                </TextSubHeader>
                <CustomButton disableOnPermission={disableOnPermission} onClick={triggerFormCreate}>
                    Add
                </CustomButton>
            </div>
            {openPopup && (
                <MemberDialog
                    workflow={applicationDetail?.applicationForm?.workflow}
                    title={`${selectedRow?.email ? 'Edit' : 'Adding'} site principal investigator's delegation`}
                    isDelegateDialog
                    disablePosition
                    isSIDelegation
                    restrictApplicant
                    selectedRow={selectedRow}
                    onDialogCancel={() => setOpenPopup(false)}
                    onCreateSubmit={(data) => {
                        // check if email existed
                        const isExist = rows.find((item) => {
                            return compareEmail(item.email, data.email);
                        });

                        if (isExist) {
                            showDialog({
                                description: EMAIL_EXIST_EMAIL,
                                disableCancelButton: true,
                            });
                        }

                        if (!isExist) {
                            handleCreateAfterCreation(data);
                        }

                        setOpenPopup(false);
                    }}
                    onEditSubmit={(data) => {
                        handleEditAfterCreation(data);
                        setOpenPopup(false);
                    }}
                    isEdit={isEdit}
                />
            )}
            <CustomTable
                disableOnPermission={disableOnPermission}
                fullWidthTable
                columns={columns}
                rows={rows}
                isEditAllow
                isDeleteAllow
                onDelete={(data) => handleDeleteAfterCreation(data)}
                onEdit={handleEditClick}
            />
        </>
    );
};

export default SiteDelegationTable;
